'use client'

import type { GetAllCollectionsOutputDTO } from '@algoacademy/backend/modules/docs/endpoints/queries/get-all-collections/output.dto'
import { cn } from '@algoacademy/design-system/shared/cn'
import { Tabs } from '@algoacademy/design-system/web/navigation/Tabs'
import { type Dispatch, type SetStateAction, useState } from 'react'
import { CollectionsGrid } from './CollectionsGrid'

enum COLLECTION_TABS {
  PUBLIC = 'Ogólnodostępne',
  ASSIGNED = 'Dla mnie'
}

type LoggedInCollectionsViewProps = {
  publicCollections: GetAllCollectionsOutputDTO['allCollections']
  assignedCollections: GetAllCollectionsOutputDTO['allCollections']
}

export function LoggedInCollectionsView({
  publicCollections,
  assignedCollections
}: LoggedInCollectionsViewProps) {
  const [activeTab, setActiveTab] = useState<COLLECTION_TABS>(COLLECTION_TABS.PUBLIC)
  const hasManyCollectionsToDidplay = publicCollections.length > 6 || assignedCollections.length > 6

  return (
    <section
      className={cn(
        'mx-auto flex flex-col gap-6',
        hasManyCollectionsToDidplay ? 'max-w-full' : 'max-w-4xl'
      )}
    >
      <Tabs
        tabs={Object.values(COLLECTION_TABS).map(tab => ({ label: tab }))}
        activeTab={activeTab}
        setActiveTab={setActiveTab as Dispatch<SetStateAction<string>>}
      />
      {
        {
          [COLLECTION_TABS.PUBLIC]: (
            <CollectionsGrid
              collections={publicCollections}
              emptyMessage='Brak publicznych kolekcji'
            />
          ),
          [COLLECTION_TABS.ASSIGNED]: <CollectionsGrid collections={assignedCollections} />
        }[activeTab]
      }
    </section>
  )
}
